// The sections of a short video, in speaking order. `short` is the chip label, `title` the heading in a plan.
export const SECTIONS = [
  { key: 'hook', emoji: '🎣', short: 'Hook', title: 'Hook', hint: 'The first 3 seconds: why should they keep watching?' },
  { key: 'explain', emoji: '💡', short: 'Explain', title: 'The idea', hint: 'The teaching itself, in plain words.' },
  { key: 'mistake', emoji: '⚠️', short: 'Mistake', title: 'Common mistake', hint: 'What most players do wrong.' },
  { key: 'drill', emoji: '🏋️', short: 'Drill', title: 'Try this', hint: 'One drill or cue to take away.' },
  { key: 'recap', emoji: '🔁', short: 'Recap', title: 'Recap', hint: 'One line to remember.' }
];

export const STATUSES = [
  { key: 'idea', label: 'Idea', emoji: '💭' },
  { key: 'scripted', label: 'Scripted', emoji: '📝' },
  { key: 'filmed', label: 'Filmed', emoji: '🎥' },
  { key: 'posted', label: 'Posted', emoji: '✅' }
];

export const TARGETS = [30, 45, 60, 90];

export const WORDS_PER_SECOND = 2.5; // matches the backend estimate

export const wordCount = (s) => (String(s || '').trim().match(/\S+/g) || []).length;
export const estimateSeconds = (items) => Math.round(items.reduce((n, it) => n + wordCount(it.text), 0) / WORDS_PER_SECOND);
export const formatSeconds = (s) => (s >= 60 ? `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}` : `${s}s`);
